"use strict";

import Vue from 'vue';
import axios from "axios";
import { useWalletStore, useAlertStore } from "@/pinia";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Handle 401 Unauthorized error
    if (error?.response && error?.response?.status === 401) {
      // Show session expired notification using Alert Store
      const alertStore = useAlertStore();
      alertStore.error(
        "Session Expired",
        "Please login again"
      );
      
      // Clear auth tokens like logout()
      localStorage.removeItem("walletName");
      localStorage.removeItem("fluxbot:auth");
      
      // Clear wallet store
      const walletStore = useWalletStore();
      walletStore.clearWallet();
      
      // Redirect to login page
      window.location.href = "/auth/login";
      
      // Return resolved promise to prevent error from being thrown
      return Promise.resolve();
    }
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
